var render, staticRenderFns
import script from "./FavoriteLots.vue?vue&type=script&lang=js&"
export * from "./FavoriteLots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee104476",
  null
  
)

export default component.exports